import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { homeForRole } from "@/lib/api";

export default function GoogleCallback() {
  const { googleExchange } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    const savedState = sessionStorage.getItem("g_oauth_state");
    sessionStorage.removeItem("g_oauth_state");

    (async () => {
      if (params.get("error") || !code) {
        setError("Sign-in was cancelled.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
        return;
      }
      if (!state || state !== savedState) {
        setError("Security check failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
        return;
      }
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const user = await googleExchange(code, redirectUri);
        const dest = user.role === "STUDENT" && !user.onboardingCompleted ? "/onboarding" : homeForRole(user.role);
        navigate(dest, { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    })();
  }, [location.search, googleExchange, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 text-muted-foreground" data-testid="google-callback">
      <Loader2 className="h-6 w-6 animate-spin" />
      <p>{error || "Signing you in…"}</p>
    </div>
  );
}
